import React from 'react'

export const Certificate = props => (
  <svg
    width={48}
    height={48}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path 
        d="M38 22C41.3138 22 44 24.6862 44 28C44 29.777 43.2276 31.3736 42 32.4722V42.382C42 43.1254 41.2176 43.6088 40.5528 43.2764L38 42L35.4472 43.2764C34.7824 43.6088 34 43.1254 34 42.382V32.4722C32.7726 31.3736 32 29.777 32 28C32 24.6862 34.6862 22 38 22ZM40 8C42.2092 8 44 9.79086 44 12V19.9993C42.3286 18.7439 40.2512 18 38 18C32.4772 18 28 22.4772 28 28C28 30.2508 28.7466 32.3304 30 34.0002V40H8C5.79086 40 4 38.2092 4 36V12C4 9.79086 5.79086 8 8 8H40ZM16 26H12C10.8954 26 10 26.8954 10 28C10 29.1046 10.8954 30 12 30H16C17.1046 30 18 29.1046 18 28C18 26.8954 17.1046 26 16 26ZM24 18H12C10.8954 18 10 18.8954 10 20C10 21.0257 10.7721 21.871 11.7668 21.9865L12 22H24C25.1046 22 26 21.1046 26 20C26 18.9743 25.2279 18.129 24.2332 18.0135L24 18Z" 
    />
  </svg>
)